export const normalizePhoneNumber = (phonenumber: string) => {
  if (phonenumber.match('^(\\+[1-9]{1,4}).?([0-9]{10})?$')) {
    return phonenumber;
  }
  return `+549${phonenumber}`;
};
